import { AppState } from './../index';
import { createSelector } from '@ngrx/store';
import { Attachment, MessageStatusType } from '@repo/shared/src/services/messaging-service/messaging-service.types';
import * as fromReducer from './reducers';

export const selectFeature = (state: AppState) => state.message;

export const selectMessageList = createSelector(selectFeature, fromReducer.selectAllMessages);

export const selectMessageListNotDraft = createSelector(selectMessageList, messages =>
  messages.filter(message => message.status !== MessageStatusType.Draft),
);

export const selectMessageDraft = createSelector(selectMessageList, messages => {
  const draft = messages.find(message => message.status === MessageStatusType.Draft);
  return draft ?? null;
});

export const getAttachmentsList = createSelector(selectMessageList, messages => {
  const attachmentsStub = new Array<Attachment>();
  messages
    .filter(message => message.messageContent.attachments.length > 0)
    .map(message => message.messageContent.attachments.map(attachment => attachmentsStub.push(attachment)));
  return attachmentsStub;
});

export const getMessageError = createSelector(selectFeature, fromReducer.getMessageError);
export const postMessageError = createSelector(selectFeature, fromReducer.postMessageError);

export const hasMessageError = createSelector(
  selectFeature,
  state => !!state.getMessageError || !!state.postMessageError,
);
export const hasGetMessageError = createSelector(selectFeature, state => !!state.getMessageError);
export const hasPostMessageError = createSelector(selectFeature, state => !!state.postMessageError);

export const idMessagesLoaded = createSelector(selectFeature, state => state.idMessagesLoaded);

export const isMessageLoaded = createSelector(selectFeature, state => state.isLoaded);

export const isMessageActionPending = createSelector(selectFeature, state => state.isMessageActionPending);

export const isMessageActionNoDraftPending = createSelector(
  selectFeature,
  state => state.isMessageActionNoDraftPending,
);

export const isResetTextAreaNeeded = createSelector(selectFeature, state => state.isResetTextAreaNeeded);
